function WindowOrder(data, corrections) {

    let height = data.height;
    let width = data.width;
    let number = data.number;
    let position = data.position;
    let comment = data.commentsWindow;

    this.height = height-corrections.window_height_correction;
    this.width = width-corrections.window_width_correction;
    this.number = number;
    this.description = "Draairaam " + this.width + " x " + this.height;
    if(position)
        this.description += " Pos: " + position;

    if(comment)
        this.description += "   Opmerking: " + comment;
}

export default WindowOrder


// WEBPACK FOOTER //
// ./src/data/WindowOrder.js